/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * UIBFS User Service API
 * API documentation for UIBFS User Service - handles authentication, user management, and profile operations
 * OpenAPI spec version: 1.0.0
 */

/**
 * Apps the account is allowed to access.
 */
export type SignUpRequestAllowedApps =
  (typeof SignUpRequestAllowedApps)[keyof typeof SignUpRequestAllowedApps];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignUpRequestAllowedApps = {
  MEMBERSHIP_PORTAL: "MEMBERSHIP_PORTAL",
  SPORTS_PORTAL: "SPORTS_PORTAL",
  LEAVE_PORTAL: "LEAVE_PORTAL",
  STUDENTS_PORTAL: "STUDENTS_PORTAL",
  EVENTS_PORTAL: "EVENTS_PORTAL",
} as const;
